module.exports = __webpack_public_path__ + "img/1537824543.27da43df.jpg";